<div
    class="agpr-listMembership"
    [style.display]="selected ? '' : 'none'"
    role="tabpanel"
    [id]="id + '.panel'"
    [attr.aria-labelledby]="id"
>
    <ng-template #tabHeader>
        @if (!hideBusinessCard) {
            <agpr-entity-business-card
                [id]="id + '_listMembershipBusinessCard'"
                [isRHP]="true"
                [entity]="focusedRhpResult"
                [canOpenFullProfile]="false"
                [contactPrivateData]="contactPrivateData"
                [outletPrivateData]="outletPrivateData"
                (selectedEmploymentChanged)="targetingRhpContextsService.changeSelectedEmployment($event.id)"
                [isCondensedMode]="true"
            ></agpr-entity-business-card>
        }
    </ng-template>

    <label class="agpr-listMembership-total">
        {{'Discover.targeting.rhp.totalLists' | localize : { count: dataRows?.length} }}
    </label>
    <agpr-text-input
        class="agpr-listMembership-input"
        ariaLabel="Discover.targeting.rhp.tabs.listMembership.filterPlaceholder"
        [id]="'listPicker.filterTextInput'"
        [(ngModel)]="filterString"
        (ngModelChange)="filterRows()"
        [bottomMargin]="false"
        [placeholder]="'Discover.targeting.rhp.tabs.listMembership.filterPlaceholder'"
    ></agpr-text-input>
    <div class="agpr-listMembership-tableContainer"            >
        @if(filteredRows?.length > 0) {
            <agpr-table
                [id]="id + '_listMembershipTable'"
                class="agpr-listMembership-table"
                [columns]="columnDefs"
                [sortColumn]="nameColumn"
                [showDelete]="false"
                [sortAscending]="true"
                [(ngModel)]="filteredRows"
                [enableSelectAll]="false"
            ></agpr-table>
        } @else {
            <agpr-message
                [severity]="messageSeverityEnum.noContent"
                [useWhiteBg]="true"
            >
                <span> {{ 'Discover.manageList.listSummary.noContent' | localize }} </span>
            </agpr-message>
        }
    </div>

    <ng-template #tabFooter>
        <agpr-action-bar
            [headingContext]="'list' | localize"
            headingLevel="4"
        >
            <ng-template #right>
                <agpr-button
                    label="Discover.manageList.header"
                    id="targetingResults.rhp.contactdetails.addToList"
                    [style]="buttonTypes.tertiary"
                    (click)="openManageListDialog()"
                ></agpr-button>
            </ng-template>
        </agpr-action-bar>
    </ng-template>
</div>

<ng-template let-row="row" let-column="column" let-selectedRow="selectedRow" #nameListCell>
    <div
        class="agpr-listMembership-nameLink"
        [agprTooltip]="row[column.field]"
        tooltipPosition="left"
    >
        {{ row[column.field] }}
    </div>
</ng-template>

<ng-template let-row="row" let-column="column" let-selectedRow="selectedRow" #countInfoCell>
    <div
        class="agpr-listMembership-countLabel"
    >
        {{ row.count || 0 }}
    </div>
</ng-template>

<ng-template let-row="row" let-column="column" let-selectedRow="selectedRow" #handlerCell>
    <div class="agpr-listMembership-handlerCell">
        @if(row.modifiedUser) {
            <agpr-button
                class="agpr-listMembership-infoCircle"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-circle-info"
                [agprTooltip]="'Tags.manageDialog.tagGroupInformation' | localize : {
                    createdDate: row.createdDate,
                    createdBy: row.createdUser,
                    modifiedDate: row.modifiedDate,
                    modifiedBy: row.modifiedUser
                }"
                tooltipPosition="left"
                [initiallyFocusable]="false"
            ></agpr-button>
        } @else {
            <agpr-button
                class="agpr-listMembership-infoCircle"
                [style]="buttonTypes.icon"
                icon="fa-regular fa-circle-info"
                [agprTooltip]="'Tags.manageDialog.tagGroupInformation.unmodified' | localize : {
                    createdDate: row.createdDate,
                    createdBy: row.createdUser
                }"
                tooltipPosition="left"
                [initiallyFocusable]="false"
            ></agpr-button>
        }
        <agpr-button
            class="agpr-listMembership-viewList"
            [style]="buttonTypes.icon"
            icon="fa-regular fa-duotone fa-up-right-from-square"
            tooltip="Discover.targeting.rhp.tabs.listMembership.rowSelectedAriaLabel"
            tooltipPosition="left"
            [tabIndex]="-1"
            (click)="openTargetingListTab(row)"
        ></agpr-button>
    </div>
</ng-template>
